module.exports = __webpack_public_path__ + "static/vente-directe1-f6e63a625a1743aac7e8b3aa7cf0b443.svg";